import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/drop-down-icon-close.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-00819dbc")

_pushScopeId("data-v-00819dbc")
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "sub-navs"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "router-link-wrapper"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "router-link-content",
  style: {"cursor":"pointer"}
}, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("a", {
      target: "_blank",
      href: "https://aibee.feishu.cn/docs/doccn2dGKgNMa5IgfhoGrRaTeff"
    }, [
      /*#__PURE__*/_createVNode("img", {
        style: {"width":"16px","height":"16px","margin-left":"2px"},
        alt: "帮助文档",
        src: "/images/nav-icon-help.png",
        "data-v-2534a5df": ""
      }),
      /*#__PURE__*/_createTextVNode(" 帮助文档")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: `${_ctx.baseUrl}images/logo2.png`
      }, null, 8, ["src"])
    ]),
    _createVNode("ul", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navs, (nav) => {
        return (_openBlock(), _createBlock("li", {
          key: nav.name,
          class: "router-link-wrapper"
        }, [
          (_ctx.showNav(nav))
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [{
        'active': _ctx.$route.path.startsWith(nav.to) && !nav._children,
        'high': _ctx.$route.path.startsWith(nav.to) && nav._children,
        'hover': _ctx.hoverNav === nav.name
      }, "router-link-content"],
                onMouseenter: ($event: any) => (_ctx.hoverNav = nav.name),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverNav = null)),
                onClick: ($event: any) => (nav.show = !nav.show),
                style: {"cursor":"pointer"}
              }, [
                _createVNode("div", null, [
                  (nav._children)
                    ? (_openBlock(), _createBlock("a", _hoisted_3, [
                        (_ctx.$route.path.startsWith(nav.to))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              alt: nav.name,
                              src: `${_ctx.baseUrl}images/${nav.iconHigh}`
                            }, null, 8, ["alt", "src"]))
                          : (_openBlock(), _createBlock("img", {
                              key: 1,
                              alt: nav.name,
                              src: `${_ctx.baseUrl}images/${nav.icon}`
                            }, null, 8, ["alt", "src"])),
                        _createTextVNode(" " + _toDisplayString(nav.name), 1)
                      ]))
                    : (_ctx.$route.name === nav.name)
                      ? (_openBlock(), _createBlock("a", _hoisted_4, [
                          (_ctx.$route.path.startsWith(nav.to))
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                alt: nav.name,
                                src: `${_ctx.baseUrl}images/${nav.iconHigh}`
                              }, null, 8, ["alt", "src"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                alt: nav.name,
                                src: `${_ctx.baseUrl}images/${nav.icon}`
                              }, null, 8, ["alt", "src"])),
                          _createTextVNode(" " + _toDisplayString(nav.name), 1)
                        ]))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: nav.to
                        }, {
                          default: _withId(() => [
                            (_ctx.$route.path.startsWith(nav.to))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  alt: nav.name,
                                  src: `${_ctx.baseUrl}images/${nav.iconHigh}`
                                }, null, 8, ["alt", "src"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  alt: nav.name,
                                  src: `${_ctx.baseUrl}images/${nav.icon}`
                                }, null, 8, ["alt", "src"])),
                            _createTextVNode(" " + _toDisplayString(nav.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                ]),
                (nav._children)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      class: [{
              'down': nav.show
            }, "drop-down-icon"],
                      src: _imports_0
                    }, null, 2))
                  : _createCommentVNode("", true)
              ], 42, ["onMouseenter", "onClick"]))
            : _createCommentVNode("", true),
          (nav._children)
            ? _withDirectives((_openBlock(), _createBlock("ul", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(nav._children, (nav) => {
                  return (_openBlock(), _createBlock("li", {
                    key: nav.name,
                    class: "router-link-wrapper"
                  }, [
                    (nav._show)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: [{
                'active': _ctx.$route.path === nav.to,
                'hover': _ctx.hoverNav === nav.name
              }, "router-link-content"],
                          onMouseenter: ($event: any) => (_ctx.hoverNav = nav.name),
                          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverNav = null))
                        }, [
                          (_ctx.$route.name === nav.name)
                            ? (_openBlock(), _createBlock("a", _hoisted_6, _toDisplayString(nav.name), 1))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: nav.to
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(nav.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                        ], 42, ["onMouseenter"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512)), [
                [_vShow, nav.show]
              ])
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.isWidthDone)
        ? (_openBlock(), _createBlock("li", _hoisted_7, [
            _hoisted_8
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})